import axios, { type AxiosError } from 'axios';
import { useAuthStore } from '../stores/auth.js';
import { API_BASE_URL } from '../utils/api-base.js';

type UploadUsage = 'avatar' | 'repair' | 'event';

interface UploadImageResponse {
	ok: boolean;
	url?: string;
	error?: string;
}

const http = axios.create({ baseURL: API_BASE_URL, timeout: 60000 });

http.interceptors.request.use((config) => {
	const { token, user } = useAuthStore.getState();
	if (token) config.headers.Authorization = `Bearer ${token}`;
	if (user?.account) config.headers['X-Ulucu-Account'] = user.account;
	return config;
});

export async function uploadImage(file: File, usage: UploadUsage): Promise<{ ok: boolean; url?: string; msg?: string }> {
	const form = new FormData();
	form.append('usage', usage);
	form.append('file', file);
	try {
		const { data } = await http.post<UploadImageResponse>('/internal/upload-image', form);
		if (data.ok && data.url) return { ok: true, url: data.url };
		return { ok: false, msg: data.error || 'Upload failed' };
	} catch (e) {
		const err = e as AxiosError<UploadImageResponse>;
		return { ok: false, msg: err.response?.data?.error || err.message };
	}
}
